const Ui = (function () {

    let keywordsTemplate;
    let taxonomyTemplate;
    let scrollContainer;
    let tableViewWrapper, tableView;
    let visualisation;
    let separator;
    let perfectScrollbar;
    let body, win;
    let textTop10, textTop10Global, textBragHighlight, textDestination, textInterest;
    let bookYourStay, banner;
    let closeBack, closeButton, backButton;
    let shareModalEl, shareButton, closeModalButton;
    let aboutEl;
    let taxonomyToggle;

    const shareableClassName = '-is-shareable';
    const enabledClassName = '-enabled';
    const activeClassName = '-is-active';

    function init() {
        body = $('body');
        win = $(window);
        keywordsTemplate = Handlebars.compile( $('#keywords-list-template').html() );
        taxonomyTemplate = Handlebars.compile( $('#taxonomy-list-template').html() );
        tableViewWrapper = $('#tableview-wrapper');
        tableView = scrollContainer = $('#tableview');
        visualisation = $('#visualisation');
        separator = $('.separator');
        // Text headers
        textTop10 = $('#heading .-top10');
        textTop10Global = $('#heading .-top10-global');
        textBragHighlight = $('#heading .-brag-highlight');
        textDestination = $('#heading .-destination');
        textInterest = $('#heading .-interest');
        bookYourStay = $('#bookyourstay');
        banner = $('#banner');
        closeBack = $('#closeback');
        closeButton = $('.close', closeBack);
        backButton = $('.back', closeBack);
        taxonomyToggle = $('#taxonomy-toggle');
        shareButton = $('#share-button .pill');
        closeModalButton = $('#share-controls .close');
        shareModalEl = $('#share-modal');
        aboutEl = $('#readmore');

        registerEvents();

        setTimeout(initScrollView, 60);
        setTimeout(setInitialState, 120);
    }

    function setInitialState() {
        renderBrags();
        toggleControls('taxonomyToggle');
    }

    function toggleMap() {
        const showMap = $('#controls .-map');
        const showBrags = $('#controls .-brags');
        tableViewWrapper.toggleClass(activeClassName);
        if (tableViewWrapper.hasClass(activeClassName)) {
            showMap.addClass(enabledClassName);
            showBrags.removeClass(enabledClassName);
            visualisation.removeClass(enabledClassName);
        } else {
            showBrags.addClass(enabledClassName);
            showMap.removeClass(enabledClassName);
            visualisation.addClass(enabledClassName);
        }
    }

    function showList() {
        const showMap = $('#controls .-map');
        const showBrags = $('#controls .-brags');
        showMap.addClass(enabledClassName);
        showBrags.removeClass(enabledClassName);
        visualisation.removeClass(enabledClassName);
        tableViewWrapper.addClass(activeClassName);
    }

    function initScrollView() {
        if (!scrollContainer.length) return;
        perfectScrollbar = new PerfectScrollbar(scrollContainer[0], {
            suppressScrollX: true,
        });
    }

    function updateTop10Text(text) {
        textTop10.find('[placeholder]')
            .text( Localisation.getTaxonomyTranslation(text) || text );
    }

    function updateBookYourStay(text) {
        const anchorEl = bookYourStay.find('.pill a');
        const textEl = bookYourStay.find('[taxonomy]');
        textEl.text( Localisation.getTaxonomyTranslation(text) || text );
        anchorEl.attr('href', Urls.getUrl(text) || 'https://hotels.com');
    }

    function updateBragHighlight(text) {
        textBragHighlight.find('[keyword]')
            .text(text);
    }

    function showHeader(el) {
        $('#header .text-content').removeClass(enabledClassName);
        el.addClass(enabledClassName);
    }

    function showFooter(el) {
        $('#footer > *').removeClass(enabledClassName);
        el.addClass(enabledClassName);
    }

    function renderBrags(key) {
        const names = Data.getBrags(key);
        const namesTranslated = Localisation.translateKeywords(names);
        const markup = keywordsTemplate(namesTranslated);
        const taxonomyName = Data.getTaxonomyName(key);
        const taxonomy = Data.getTaxonomy(key);
        tableView.html(markup);
        updateBookYourStay(taxonomyName);
        Visualisation.update(key);
        perfectScrollbar.update();
        switch (taxonomy) {
            case 'locations': {
                showHeader(textTop10);
                updateTop10Text(taxonomyName);
                showFooter(bookYourStay);
                toggleControls('closeBack', key);
                body.addClass(shareableClassName);
                let coords = Data.getLocationCoords(key.replace('locations/',''));
                if (coords) {
                    Visualisation.getGlobe().updateTarget(coords[0], coords[1]);
                }
                highlightTextLabel(taxonomyName);
                Visualisation.getGlobe().updateZoom(650);
                break;
            }
            case 'global':
                showHeader(textTop10Global);
                showFooter(banner);
                toggleControls('taxonomyToggle');
                body.removeClass(shareableClassName);
                Visualisation.getGlobe().updateZoom(1000);
                break;
            default:
                showHeader(textTop10);
                updateTop10Text(taxonomyName);
                showFooter(banner);
                toggleControls('closeBack', key);
                body.addClass(shareableClassName);
                Visualisation.getGlobe().updateZoom(650);
        }
    }

    function renderBragsHandler() {
        const el = $(this).parent();
        const dataset = el.data();
        const type = dataset.type;
        const key = dataset.key;
        renderBrags(`${type}/${key}`);
    }

    function renderLocations() {
        const names = Data.getLocations();
        const namesTranslated = Localisation.translateTaxonomies(names);
        const markup = taxonomyTemplate(namesTranslated);
        tableView.html(markup);
        showList();
        showHeader(textDestination);
        perfectScrollbar.update();
        toggleControls('closeBack', 'locations');
        body.removeClass(shareableClassName);
    }

    function renderCategories() {
        const names = Data.getCategories();
        const namesTranslated = Localisation.translateTaxonomies(names);
        const markup = taxonomyTemplate(namesTranslated);
        tableView.html(markup);
        showList();
        showHeader(textInterest);
        perfectScrollbar.update();
        toggleControls('closeBack', 'categories');
        body.removeClass(shareableClassName);
    }

    function highlightTextLabel(locationName) {
        const labels = Visualisation.getGlobe().getTextLabels();
        labels.forEach(label => {
            const el = $(label.element);
            el.removeClass(activeClassName);
            if (label.text === locationName) {
                el.addClass(activeClassName);
            }
        });
    }

    function highlightBragHandler() {
        const el = $(this).parent();
        const dataset = el.data();
        const key = dataset.key;
        if (el.hasClass(activeClassName)) {
            el.removeClass(activeClassName);
            highlightBrag();
            if (key === 'global') {
                showHeader(textTop10Global);
            } else {
                showHeader(textTop10);
            }
            return;
        }
        el.siblings().toArray().map($).forEach(elm => elm.removeClass(activeClassName));
        el.addClass(activeClassName);
        highlightBrag(el[0].dataset.name);
        toggleMap();
    }

    function highlightBrag(name = '') {
        Visualisation.getGlobe().highlightGroup(name);
        updateBragHighlight( name );
        showHeader(textBragHighlight);
        body.addClass(shareableClassName);
    }

    function showCloseBack(key = 'global') {
        closeBack.addClass(enabledClassName);
        closeButton.removeClass(enabledClassName);
        backButton.removeClass(enabledClassName);
        switch (key) {
            case 'locations':
            case 'categories':
                closeButton.addClass(enabledClassName);
                closeButton.data('dest', 'global');
                break;
            case 'global':
                break;
            default:
                backButton.addClass(enabledClassName);
                backButton.data('dest', Data.getTaxonomy(key));
        }
    }

    function toggleControls(mode, key) {
        taxonomyToggle.removeClass(enabledClassName);
        closeBack.removeClass(enabledClassName);

        switch (mode) {
            case 'closeBack':
                showCloseBack(key);
                break;
            case 'taxonomyToggle':
                taxonomyToggle.addClass(enabledClassName);
                break;
            default:
        }
    }

    function closeBackHandler() {
        highlightTextLabel();
        const dest = $(this).data('dest');
        switch (dest) {
            case 'locations':
                renderLocations();
                break;
            case 'categories':
                renderCategories();
                break;
            case 'global':
                renderBrags();
                break;
            default:
                renderBrags();
        }
    }

    function toggleShareModal () {
        shareModalEl.toggleClass(activeClassName);
    }

    function toggleAbout() {
        aboutEl.toggleClass(activeClassName);
    }

    /*
    function setScrollViewHeight() {
        let prevSibling = scrollContainer.prev();
        let nextSibling = scrollContainer.next();
        let prevSiblingOffset = prevSibling.offset();
        let prevSiblingHeight = prevSibling.outerHeight();
        let nextSiblingOffset = nextSibling.offset();
        let height = nextSiblingOffset.top - prevSiblingOffset.top + prevSiblingHeight;
        scrollContainer.height(height);
    }
    */

    function registerEvents() {
        body.on('click.toggleMap', '#toggle-map .pill', toggleMap);
        body.on('click.renderLocations', '#show-destinations', renderLocations);
        body.on('click.renderCategories', '#show-interests', renderCategories);
        body.on('click.renderBragsHandler', '.taxonomy-item a', renderBragsHandler);
        body.on('click.highlightBragHandler', '.keyword-item a', highlightBragHandler);
        body.on('click.closeBackHandler', '#closeback > .' + enabledClassName, closeBackHandler);
        body.on('click.toggleShareModal', '#share-button .pill, #share-controls .close', toggleShareModal);
        body.on('click.toggleAbout', '#readmore .close, .readmore span', toggleAbout);
    }

    return { init };
})();
